import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { insights } from '../data/profile';
import { SectionHeading } from '../components/SectionHeading';
export function Insights() {
  return <section className="min-h-[70vh] bg-white pt-32 pb-24 lg:pb-32" data-id="element-227" data-mp="256ot43c803ne">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10" data-id="element-228" data-mp="2a3f8eog7av7r">
        <SectionHeading eyebrow="THOUGHT LEADERSHIP AND INSIGHTS" title="Perspectives on procurement transformation" intro="Commentary and case studies drawn from live transformation programmes across financial services, hospitality, and consumer packaged goods." data-id="element-229" data-mp="2a1uen11pngay" />

        <ul className="mt-14 grid gap-8 lg:grid-cols-3" data-id="element-230" data-mp="2supt2nvc2br7">
          {insights.map(article => <li key={article.title} className="flex" data-id="element-231" data-mp="1cgg7g1ih7142">
              <Link to="/contact" className="group flex w-full flex-col border-t-2 border-ink/80 pt-7 transition-colors duration-150 ease-exec hover:border-gold-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400" data-id="element-232" data-mp="1cevay6clp83k">
                <span className="text-sm tracking-wider2 text-grass-600" data-id="element-233" data-mp="o2nvp80oecs8">
                  {article.category.toUpperCase()}
                </span>
                <h3 className="mt-4 text-2xl leading-snug text-ink transition-colors duration-150 ease-exec group-hover:text-grass-700" data-id="element-234" data-mp="11z13tqjbl1u1">
                  {article.title}
                </h3>
                <p className="mt-4 text-base leading-relaxed text-slate-600" data-id="element-235" data-mp="1azz889xo7bd5">{article.copy}</p>
                <span className="mt-auto flex items-center justify-between pt-8 text-base text-slate-500" data-id="element-236" data-mp="16ye1l6bqbtbe">
                  {article.readTime}
                  <ArrowUpRightIcon className="h-5 w-5 text-gold-500 transition-transform duration-150 ease-exec group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-237" data-mp="1fsabnmrmdfag" />
                </span>
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}